import Clickable from 'components/Common/Clickable'
import HelpPane from 'components/Common/HelpPane/HelpPane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import SolidInfoCircleIcon from 'components/Luxkit/Icons/solid/SolidInfoCircleIcon'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { dateIsBefore } from 'lib/datetime/dateUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useContext, useMemo } from 'react'

interface Props {
  policy: App.CarHireCancellationPolicy;
}

function CarHireCancellationPolicyText(props: Props) {
  const { policy } = props

  const showModal = useContext(ModalContext)

  const policyMaxDate = useMemo(() => new Date(policy.maxDate), [policy])
  const available = useMemo(() => dateIsBefore(new Date(), policyMaxDate), [policyMaxDate])

  const onTextClick = () => {
    showModal(<Modal title={available ? 'Free cancellation' : 'Non-refundable'}>
      <VerticalSpacer gap={24}>
        <BodyText variant="large">
          {available && `You can cancel for free up to ${pluralizeToString('hour', policy.maxHours)} before pick-up.`}
          {!available && `Unfortunately, as the pick-up for your car hire is within the next ${pluralizeToString('hour', policy.maxHours)}, your booking is non-refundable.`}
        </BodyText>
        <HelpPane />
      </VerticalSpacer>
    </Modal>)
  }

  return (
    <Clickable onClick={onTextClick}>
      <Group direction="horizontal" gap={4} verticalAlign="center">
        {available && <BodyText variant="medium" colour="neutral-two">
          <BodyText as="span" variant="medium" colour="highlight-secondary" weight="bold">Free cancellation</BodyText>{' '}
          until <FormatDateTime value={policyMaxDate} format="short-day-name-day-month" />
        </BodyText>}
        {!available && <BodyText variant="medium" colour="neutral-two">Non-refundable</BodyText>}
        <SolidInfoCircleIcon colour="neutral-one" size="XS" />
      </Group>
    </Clickable>
  )
}

export default CarHireCancellationPolicyText
